import React from "react";
import LicenseChip from "components/LicenseChip";
import { ACTIVATION_TYPES } from "utils/constants";
import DisclosureCard from "components/DisclosureCard";
import GridDetailsLayout from "components/GridDetailsLayout";
import ActivationBadgeType from "components/ActivationTypeBadge";

const CardSx = ({ state }) => {
    return (
        <DisclosureCard
            extra={"w-full p-4 sm:overflow-x-auto"}
            button={() => (
                <div className="relative flex items-center justify-between">
                    <div className="flex">
                        <div className="text-2xl font-bold text-gray-800 dark:text-white">
                            Riepilogo attivazione #{state.code}
                        </div>
                    </div>

                    <div>
                        <img
                            src="/icon/chevron-down.svg"
                            alt="Riepilogo attivazione"
                            className="group-data-open:rotate-180 text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                        />
                    </div>
                </div>
            )}
            content={() => (
                <GridDetailsLayout
                    dataConfig={[
                        {
                            key: "Ordine Nr.",
                            value: state.data?.reseller_code,
                        },
                        {
                            key: "Data",
                            value: state.created_at,
                        },
                        {
                            key: "Tipologia attivazione",
                            value: (
                                <ActivationBadgeType
                                    text={state.type}
                                    className="ml-1"
                                />
                            ),
                        },
                        ...(state.type === ACTIVATION_TYPES.ONSITE
                            ? [
                                  {
                                      key: "Tipologia maintenance",
                                      value:
                                          state.data?.maintenance !== undefined
                                              ? state.data?.maintenance ===
                                                "lifetime"
                                                  ? state.data?.maintenance
                                                  : state.data?.maintenance ===
                                                        0 ||
                                                    state.data?.maintenance ===
                                                        "0"
                                                  ? "1 anno incluso"
                                                  : Number(
                                                        state.data?.maintenance
                                                    ) +
                                                    1 +
                                                    " anni (1 incluso + " +
                                                    state.data?.maintenance +
                                                    " " +
                                                    (state.data?.maintenance ===
                                                        1 ||
                                                    state.data?.maintenance ===
                                                        "1"
                                                        ? "selezionato"
                                                        : "selezionati") +
                                                    ")"
                                              : "",
                                  },
                              ]
                            : []),
                        ...(state.type === ACTIVATION_TYPES.ONSITE
                            ? [
                                  {
                                      key: "Certificato SSL annuale + dominio",
                                      value: state?.data?.licenses?.find(
                                          (x) => x.code === "ssl"
                                      )?.active
                                          ? "Sì (" +
                                            (state.data?.maintenance ===
                                            "lifetime"
                                                ? state.data?.maintenance
                                                : state.data?.maintenance ===
                                                      0 ||
                                                  state.data?.maintenance ===
                                                      "0"
                                                ? "1 anno"
                                                : Number(
                                                      state.data?.maintenance
                                                  ) +
                                                  1 +
                                                  " anni") +
                                            ")"
                                          : "No",
                                  },
                              ]
                            : []),
                        {
                            key: "Tipologia licenza",
                            value: state.data?.subtype,
                        },
                        {
                            key: "Licenze",
                            value: state?.data?.licenses?.length ? (
                                <div className="ml-1 flex flex-wrap gap-2">
                                    {state.data.licenses.map(
                                        ({
                                            active,
                                            code,
                                            name,
                                            qty,
                                            tooltip,
                                        }) => {
                                            if (!active || code === "ssl") {
                                                return null;
                                            }

                                            return (
                                                <React.Fragment key={code}>
                                                    <LicenseChip
                                                        name={name}
                                                        quantity={qty}
                                                        tooltip={tooltip}
                                                    />
                                                </React.Fragment>
                                            );
                                        }
                                    )}
                                </div>
                            ) : null,
                        },
                        {
                            key: "Note ordine",
                            value: state.data.reseller_note,
                        },
                    ]}
                />
            )}
        />
    );
};

export default CardSx;
